import { render } from "./MicroButton.vue?vue&type=template&id=0b7a85a5&scoped=true&ts=true"
import script from "./MicroButton.vue?vue&type=script&lang=ts"
export * from "./MicroButton.vue?vue&type=script&lang=ts"

import "./MicroButton.vue?vue&type=style&index=0&id=0b7a85a5&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7a85a5"]])

export default __exports__